import React from 'react';
import { Localization } from 'connex-cds';

const { useTranslateObjects, useTranslateMessage } = Localization;

const getConcreteClassStringId = id => `SETUP_CONCRETE-CLASSES_${id}-NAME`.replace(/\s/gi, '_').toUpperCase();

/**
 * Renders a material-compliance field label, optionally suffixed with the associated concrete class
 * name and its min/max range: `{Material Compliance label}: {Concrete Class name}-({min} - {max})`.
 * Shows a warning text when the entered value is outside that range.
 */
export const MaterialComplianceLabel = ({ materialCompliance, concreteClass, outOfRange = false }) => {
  const { translateObjects } = useTranslateObjects();
  const translateMessage = useTranslateMessage();

  const translateName = record => {
    if (!record) return '';

    const [translated] = translateObjects([record], {
      getStringId: getConcreteClassStringId,
      getPath: 'id',
      setPath: 'label',
      defaultMessagePath: 'name',
    });

    return translated?.label ?? '';
  };

  const label = translateName(materialCompliance);
  const rangeSuffix = concreteClass
    ? ` ${translateName(concreteClass)} (${concreteClass?.minimumValue} - ${concreteClass?.maximumValue})`
    : '';

  return (
    <label className="translate-label">
      {label}:{rangeSuffix}
      {outOfRange && (
        <span className="material-compliance-range-warning" data-testid="materialComplianceRangeWarning">
          {' ' + translateMessage('materialCompliance_outOfRange_warning')}
        </span>
      )}
    </label>
  );
};
